export default __webpack_public_path__ + "static/media/About-4.0b117d01.jpeg";